// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"30deefa8","245":"ca40a16d","441":"cbb9410b","564":"dac9672b","935":"29b238f8"}[chunkId] + ".chunk.js";
};